import types from '../constants'

const initialState = {
  inbox: {
    meta: {
      page: 1,
      status: 'loading',
      haveNextPage: false,
      loadingState: true,
    },
    data: [],
  },
  inboxDetail: {
    meta: {
      status: 'loading',
    },
    data: null,
  },
  sortActive: 'desc',
  inboxNotifBadgesTour: {
    steps: [
      {
        target: '.test',
        title: 'Notif Badge',
        content: 'Klik tombol account untuk melihat menu Inbox',
        placement: 'left-start',
        disableBeacon: true,
      },
    ],
    run: false
  },
  category: {
    meta: {
      status: 'loading'
    },
    data: [],
    categoryActive: 0
  },
  counter: {
    meta: {
      status: 'loading'
    },
    data: {
      unread: 0
    }
  }
}

export default function matches(state = initialState, action) {
  switch (action.type) {
    case types.GET_INBOX_LOADING:
      return {
        ...state,
        inbox: {
          ...action.payload,
        },
      }
    case types.GET_INBOX_SUCCESS:
      return {
        ...state,
        inbox: {
          ...action.payload,
        },
      }
    case types.GET_INBOX_ERROR:
      return {
        ...state,
        inbox: {
          ...action.payload,
        },
      }

    case types.GET_INBOX_DETAIL_LOADING:
      return {
        ...state,
        inboxDetail: {
          ...action.payload,
        },
      }
    case types.GET_INBOX_DETAIL_SUCCESS:
      return {
        ...state,
        inboxDetail: {
          ...action.payload,
        },
      }
    case types.GET_INBOX_DETAIL_ERROR:
      return {
        ...state,
        inboxDetail: {
          ...action.payload,
        },
      }
    case types.INBOX_FILTER_ACTIVE:
      return {
        ...state,
        sortActive: action.payload
      }
    case types.INBOX_NOTIF_BADGES_TOUR:
      return {
        ...state,
        inboxNotifBadgesTour: {
          ...state.inboxNotifBadgesTour,
          run: action.payload
        }
      }

    case types.GET_INBOX_CATEGORY_LOADING:
      return {
        ...state,
        category: {
          ...action.payload,
        },
      }
    case types.GET_INBOX_CATEGORY_SUCCESS:
      return {
        ...state,
        category: {
          ...action.payload,
        },
      }
    case types.GET_INBOX_CATEGORY_ERROR:
      return {
        ...state,
        category: {
          ...action.payload,
        },
      }
    case types.CHANGE_CATEGORY_ACTIVE:
      return {
        ...state,
        category: {
          ...state.category,
          categoryActive: action.payload
        }
      }
    case types.GET_COUNTER_INBOX_LOADING:
      return {
        ...state,
        counter: {
          ...action.payload
        }
      }
    case types.GET_COUNTER_INBOX_SUCCESS:
      return {
        ...state,
        counter: {
          ...action.payload
        }
      }
    case types.GET_COUNTER_INBOX_ERROR:
      return {
        ...state,
        counter: {
          ...action.payload
        }
      }

    default:
      return {
        ...initialState,
        ...state,
      }
  }
}
